import dayjs from 'dayjs';

/**
 * @desc 根据index生成A~Z,AA～AZ, BA~BZ,......”字母编号, 生成excel表格的列名
 */
export function getLetterByIndex(index: number): string {
  let result = '';
  while (index >= 0) {
    // 计算当前位的字母
    const remainder = index % 26;
    result = String.fromCharCode(65 + remainder) + result;
    // 更新索引
    index = Math.floor(index / 26) - 1;
  }
  return result;
}

/**
 * @desc 根据下标生成表格列的字母编号key
 */
export function generateColumnsKey(cols: Recordable[]) {
  return cols.map((item, idx) => {
    return {
      ...item,
      key: getLetterByIndex(idx),
      letter: { val: getLetterByIndex(idx), text: getLetterByIndex(idx) },
    };
  });
}

/**
 * 格式化excel时间
 */
export function formatExcelDate(numb: number, format?: '-') {
  const time: any = new Date(
    (numb - 25567) * 24 * 3600000 -
      5 * 60 * 1000 -
      43 * 1000 -
      24 * 3600000 -
      8 * 3600000
  );
  time.setYear(time.getFullYear());
  const year = `${time.getFullYear()}`;
  const month = time.getMonth() + 1;
  const date = time.getDate();
  if (format && format.length === 1) {
    return year + format + month + format + date;
  }
  return `${year}${month < 10 ? `0${month}` : month}${
    date < 10 ? `0${date}` : date
  }`;
}

/**
 * excel日期转时间戳
 */
export function excelDateToTimestamp(excelDate: number): number {
  return dayjs(formatExcelDate(excelDate)).valueOf();
}

export const commaSplitFunc = (val: any) => {
  // 使用英文逗号分割
  const wordSplit1 = String(val || '').split(',');
  const wordSplit2: Recordable[] = [];
  wordSplit1.forEach((item) => {
    // 再使用中文逗号分割
    const words = item.split('，');
    words.forEach((word: any) => {
      if (word) {
        wordSplit2.push(word);
      }
    });
  });
  if (wordSplit2.length > 0) {
    return wordSplit2;
  }
  return undefined;
};
export const semicolonSplitFunc = (val: any) => {
  // 使用英文分号分割
  const wordSplit1 = String(val || '').split(';');
  const wordSplit2: Recordable[] = [];
  wordSplit1.forEach((item) => {
    // 再使用中文分号分割
    const words = item.split('；');
    words.forEach((word: any) => {
      if (word) {
        wordSplit2.push(word);
      }
    });
  });
  if (wordSplit2.length > 0) {
    return wordSplit2;
  }
  return undefined;
};

export const trimFunc = (val: any) => {
  return val.toString().trim();
};

export const tranMaterialPropertyFunc = (val: any) => {
  const properties = commaSplitFunc(val) || [];
  return properties
    .map((prop) => {
      const props = prop.split(':');
      const splitProps: any = [];
      props.forEach((e: any) => {
        const props1 = e.split('：');
        props1.forEach((word: any) => {
          if (word) {
            splitProps.push(word);
          }
        });
      });
      if (splitProps.length === 2) {
        return {
          propertyName: splitProps[0].trim(),
          propertyValue: splitProps[1].trim(),
        };
      }
      return null;
    })
    .filter(Boolean);
};

/**
 * 验证非负数
 */
export const isNonNegativeNumber = (val: unknown) => {
  return Number.isNaN(Number(val)) || Number(val) < 0;
};

export const getCurrencyPriceVOS = (str: string) => {
  const regex = /([^(]+)\(([^)]+)\)/;
  const match = str.match(regex);
  if (match) {
    const currencyName = match[1];
    const currencyCode = match[2];
    return {
      currencyName,
      currencyCode,
    };
  }
  return {
    currencyName: '',
    currencyCode: '',
  };
};
